import { Header              } from "../../main_components/header";
import { Loading             } from "../../main_components/loading.js";
import { ViewListBody        } from "./view_list_body";
import { useState, useEffect } from "react";
export const ViewList = ( props ) => {
    const { loadingDuration } = props;
    const [ isLoaded, setIsLoaded ] = useState(false);
    const [ toggle,   setToggle   ] = useState(true);
    useEffect(() => {
        window.onload = _=> setIsLoaded(true);
        setTimeout(_=> {
            setIsLoaded(true);
            setTimeout(_=>{ setToggle(false) }, 500);
            }, loadingDuration);
    }, []);
    return (
        <>
            { toggle && <Loading page={ "View List" } isLoaded={ isLoaded }/> }
            <Header link={ "View_List" }/>
            <ViewListBody />
        </>
    );
};